import Home from "../views/pages/home";
import Diagnose from "../views/pages/diagnose";

const routes = {
    "/": Home,
    "/Home": Home,
    "/diagnose": Diagnose,
};

export default routes;